import type { RouteId } from "../../site/routes";
import type { RouteCopy } from "../types";

export const ROUTE_COPY_PT_BR = {
  home: {
    title: "Codecious - Apps que se tornam conscientes",
    description:
      "Empresa brasileira de tecnologia: apps para o dia a dia, como o Gymtero, soluções sob medida para empresas e ferramentas para desenvolvedores.",
  },
  privacyPolicy: {
    title: "Política de Privacidade | Codecious",
    description:
      "Política de privacidade da Codecious. Saiba como protegemos seus dados pessoais.",
  },
  termsOfUse: {
    title: "Termos de Uso | Codecious",
    description:
      "Termos de uso do site e serviços da Codecious. Condições gerais de utilização dos nossos apps e plataformas.",
  },
  cookiePolicy: {
    title: "Política de Cookies | Codecious",
    description:
      "Política de cookies do codecious.com: o site usa apenas armazenamento estritamente necessário, sem cookies de publicidade, analytics ou redes sociais.",
  },
  developers: {
    title: "Para desenvolvedores: Bootgly, Dataruni e Codecious Build",
    description:
      "Projetos para desenvolvedores: o framework PHP Bootgly (MIT), a biblioteca Dataruni para apps React (experimental) e o Codecious Build, com lista de espera.",
  },
  business: {
    title: "Para sua empresa: apps sob medida, PWA e Distribute | Codecious",
    description:
      "Apps e sistemas sob medida com consulta inicial gratuita, apps web progressivos (PWA), Codecious Distribute em acesso antecipado e Jobxtech para empresas.",
  },
  apps: {
    title: "Apps da Codecious: Gymtero, Nutrinima e Jobxtech",
    description:
      "Conheça os apps da Codecious: Gymtero para treinos, disponível na web e no Android, e Nutrinima e Jobxtech, em desenvolvimento, com lista de espera.",
  },
  nutrinima: {
    title: "Nutrinima - App de hábitos alimentares (em breve) | Codecious",
    description:
      "O Nutrinima, assistente de hábitos alimentares da Codecious, está em desenvolvimento. Entre na lista de espera para saber quando for lançado.",
  },
  jobxtech: {
    title: "Jobxtech - Vagas e carreira em tecnologia (em breve) | Codecious",
    description:
      "O Jobxtech, plataforma de vagas e oportunidades em tecnologia da Codecious, está em desenvolvimento. Entre na lista de espera para saber quando for lançado.",
  },
  gymteroPrivacy: {
    title: "Gymtero - Política de Privacidade | Codecious",
    description:
      "Como o app Gymtero trata seus dados: conta, treinos, dados de saúde opcionais, anúncios, pagamentos e seus direitos pela LGPD.",
  },
  gymteroDeleteAccount: {
    title: "Gymtero - Como Excluir Sua Conta | Codecious",
    description:
      "Passo a passo para excluir sua conta do Gymtero e quais dados são removidos.",
  },
  gymteroDownload: {
    title: "Gymtero - Download App de Treinos | Codecious",
    description:
      "Baixe o Gymtero, app de treinos inteligentes da Codecious: planos adaptativos, mapa muscular e acompanhamento em tempo real. Android e web.",
  },
  blogList: {
    title: "Blog Codecious — Fitness, Nutrição e Carreira Tech",
    description:
      "Artigos sobre treino, alimentação saudável e carreira em tecnologia, com dicas práticas dos apps Gymtero, Nutrinima e Jobxtech.",
  },
  blogPost: {
    // Placeholder until the post loads; BlogPost sets the real head.
    title: "Blog | Codecious",
    description: "Artigo do blog da Codecious.",
  },
  notFound: {
    title: "Página não encontrada | Codecious",
    description: "A página que você procura não existe.",
  },
} satisfies Record<RouteId, RouteCopy>;
